import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";

import requester from "../../utils/requester";

import styles from "./styles.module.scss";
import { toast } from "react-toastify";

import backArrowLogo from "../../assets/backArrow.svg";

const ALL_ENDPOINTS = [
  "/albums/getAlbumImages",
  "/aquarium/get-ticket-images",
  "/media/get-ticket-images",
  "/dolphin-house/get-ticket-images",
];

export default function AlbumLinkForm() {
  const { code } = useParams();
  const location = useLocation();
  const [showSecondStep, setShowSecondStep] = useState(false);
  const [album, setAlbum] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isAquarium = location.pathname?.includes("grand-aquarium");
  const isMedia = location.pathname?.includes("media");
  const isDolphinHouse = location.pathname?.includes("dolphin");
  const isSeaTrip = location.pathname?.includes("sea-trip");
  const isDirect = !isAquarium && !isMedia && !isDolphinHouse && !isSeaTrip;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      code: code,
      phone: undefined,
      email: undefined,
    },
  });

  function getEndpoint() {
    if (isAquarium) return "/aquarium/get-ticket-images";
    if (isMedia) return "/media/get-ticket-images";
    if (isDolphinHouse) return "/dolphin-house/get-ticket-images";
    return "/albums/getAlbumImages";
  }

  function handleAlbumData(albumData) {
    if (albumData?.serviceType === "album") {
      setAlbum(albumData);
      setShowSecondStep(true);
    } else if (albumData?.serviceType === "video") {
      window.open(albumData?.videoUrl, "_top");
    } else if (
      albumData?.serviceType === "photo" ||
      albumData.tripType === "grand-aquarium" ||
      albumData.tripType === "media" ||
      albumData.tripType === "dolphin-house"
    ) {
      window.open(albumData?.albumSharedLink, "_top");
    }
  }

  function onSubmit(data) {
    if (!data.code) return;
    setIsLoading(true);

    if (isDirect) {
      // Fire all 4 endpoints in parallel; cancel the rest as soon as one succeeds.
      const controllers = ALL_ENDPOINTS.map(() => new AbortController());
      let done = false;
      let rejectedCount = 0;
      const errors = [];

      ALL_ENDPOINTS.forEach((endpoint, i) => {
        requester()
          .get(endpoint, {
            params: { code: data.code },
            signal: controllers[i].signal,
          })
          .then((res) => {
            if (done) return;
            done = true;
            controllers.forEach((c, j) => { if (j !== i) c.abort(); });
            setIsLoading(false);
            handleAlbumData(res?.data?.data);
          })
          .catch((err) => {
            if (err?.code === "ERR_CANCELED") return;
            errors.push(err);
            rejectedCount++;
            if (rejectedCount === ALL_ENDPOINTS.length && !done) {
              setIsLoading(false);
              const has402 = errors.some((e) => e?.response?.status === 402);
              toast.info(
                <div style={{ textAlign: "center" }}>
                  {has402
                    ? "Hi👋, kindly complete your payment as we agreed with you, thanks"
                    : "Hi👋, your package will be available within 24 hours, thanks"}
                </div>
              );
            }
          });
      });
    } else {
      requester()
        .get(getEndpoint(), { params: { code: data.code } })
        .then((res) => {
          setIsLoading(false);
          handleAlbumData(res?.data?.data);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.info(
            <div style={{ textAlign: "center" }}>
              {err.response?.status === 402
                ? "Hi👋, kindly complete your payment as we agreed with you, thanks"
                : isMedia
                ? "Hi👋, your package will be available soon, thanks"
                : "Hi👋, your package will be available within 24 hours, thanks"}
            </div>
          );
        });
    }
  }

  if (showSecondStep) {
    return (
      <div className={styles.homeCont}>
        <div className={styles.home} style={{ justifyContent: "flex-start" }}>
          <div
            className={styles.backBtn}
            onClick={() => {
              setAlbum(null);
              setShowSecondStep(false);
            }}
          >
            <img src={backArrowLogo} />
            <span style={{ marginTop: 0 }}>Back</span>
          </div>

          <a className="button" href={album?.albumSharedLink} target="_blank">
            Photo
          </a>

          <a className="button" href={album?.videoUrl} target="_blank">
            Video
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.homeCont}>
      <form className={styles.home} onSubmit={handleSubmit(onSubmit)}>
        <div>GET YOUR MOMENTS</div>
        <input
          {...register("code", { required: true })}
          placeholder="Code"
          className={`input ${errors.code && "unvalid"}`}
        ></input>
        <input
          {...register("email", { pattern: { value: /\S+@\S+\.\S+/ } })}
          placeholder="Email"
          className={`input ${errors.email && "unvalid"}`}
        ></input>
        <input
          {...register("phone")}
          placeholder="Phone Number"
          className="input"
        ></input>
        <button className="button" type="submit" disabled={isLoading}>
          {isLoading ? "Loading..." : "View Files"}
        </button>
      </form>
    </div>
  );
}
